import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { KTCard, KTCardBody } from '../../../_metronic/helpers'
import { KTIcon } from '../../../_metronic/helpers'
import { Category } from './mockData'
import { add_project_category } from '../projects/api/projectCategoriesApi'
import { toast } from 'react-toastify'
import { permissionCheck } from '../../helper-functions/PermissionCheck'

const AddCategoryPage: React.FC = () => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    status: 1
  })
  const [errors, setErrors] = useState<Record<string, string>>({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const canCreateCategory = Boolean(permissionCheck('category-create'))

  const validateForm = () => {
    const newErrors: Record<string, string> = {}

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!canCreateCategory) {
      toast.error('You do not have permission to create categories')
      return
    }

    if (validateForm()) {
      try {
        setIsSubmitting(true)
        const payload = {
          category_name: formData.name.trim(),
          description: formData.description.trim(),
          status: String(formData.status)
        }
        await add_project_category(payload)
        toast.success('Category created successfully')
        navigate('/categories')
      } catch (error) {
        console.error('Error creating category:', error)
        toast.error('Failed to create category')
      } finally {
        setIsSubmitting(false)
      }
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }


  if (!canCreateCategory) {
    return (
      <>
        <PageTitle breadcrumbs={[]}>Add Category</PageTitle>
        <div className='d-flex flex-column flex-lg-row'>
          <div className='flex-lg-row-fluid'>
            <KTCard>
              <KTCardBody>
                <div className='alert alert-warning mb-0'>
                  You do not have permission to create categories.
                </div>
              </KTCardBody>
            </KTCard>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>Add Category</PageTitle>
      <div className='d-flex flex-column flex-lg-row'>
        <div className='flex-lg-row-fluid'>
          <KTCard>
          <div className='card-header'>
            <div className='card-title'>
              <h3 className='fw-bold text-dark'>Add New Category</h3>
            </div>
            <div className='card-toolbar'>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-active-color-primary'
                onClick={() => navigate('/categories')}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </button>
            </div>
          </div>
          <KTCardBody>
            <form onSubmit={handleSubmit}>
              <div className='row mb-6'>
                <div className='col-lg-6'>
                  <label className='col-form-label fw-bold fs-6'>
                    <span className='text-danger'>*</span>Category Name
                  </label>
                  <input
                    type='text'
                    name='name'
                    className={`form-control form-control-solid ${errors.name ? 'is-invalid' : ''}`}
                    placeholder='Enter category name'
                    value={formData.name}
                    onChange={handleChange}
                  />
                  {errors.name && <div className='invalid-feedback'>{errors.name}</div>}
                </div>
                <div className='col-lg-6'>
                  <label className='col-form-label fw-bold fs-6'>Status</label>
                  <select
                    name='status'
                    className='form-select form-select-solid'
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </select>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-lg-12'>
                  <label className='col-form-label fw-bold fs-6'>
                    Description
                  </label>
                  <textarea
                    name='description'
                    className={`form-control form-control-solid ${errors.description ? 'is-invalid' : ''}`}
                    rows={3}
                    placeholder='Enter category description'
                    value={formData.description}
                    onChange={handleChange}
                  />
                  {errors.description && <div className='invalid-feedback'>{errors.description}</div>}
                </div>
              </div>


              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  className='btn btn-light me-3'
                  onClick={() => navigate('/categories')}
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                >
                  <KTIcon iconName='check' className='fs-2' />
                  Save Category
                </button>
              </div>
            </form>
          </KTCardBody>
        </KTCard>
        </div>
      </div>
    </>
  )
}

export { AddCategoryPage }
